import { COMBAT_TICK_MS } from './campaignV2CombatClock.js';
/** A full cycle is: day -> dusk -> night -> dawn -> day. */
export const CAMPAIGN_V2_DAY_NIGHT_CYCLE_MS = 90_000;
/** Fractions of the cycle at which each phase begins; day also covers the cycle's start. */
export const CAMPAIGN_V2_DAY_NIGHT_PHASE_WINDOWS = {
    duskStart: 0.2,
    nightStart: 0.35,
    dawnStart: 0.65,
    dayStart: 0.85,
};
export const CAMPAIGN_V2_DAY_NIGHT_PHASE_EFFECTS = {
    day: { towerFireRateMultiplier: 1.15, enemySpeedMultiplier: 1.0 },
    dusk: { towerFireRateMultiplier: 1.05, enemySpeedMultiplier: 1.08 },
    night: { towerFireRateMultiplier: 0.9, enemySpeedMultiplier: 1.2 },
    dawn: { towerFireRateMultiplier: 1.1, enemySpeedMultiplier: 0.95 },
};
const CYCLE_TICKS = Math.round(CAMPAIGN_V2_DAY_NIGHT_CYCLE_MS / COMBAT_TICK_MS);
const windowTick = (fraction) => Math.round(fraction * CYCLE_TICKS);
/** The cycle clock is the combat tick, so a replay and a live run agree on every phase boundary. */
function resolvePhaseAtTick(tick) {
    const cycleTick = ((tick % CYCLE_TICKS) + CYCLE_TICKS) % CYCLE_TICKS;
    const windows = CAMPAIGN_V2_DAY_NIGHT_PHASE_WINDOWS;
    if (cycleTick < windowTick(windows.duskStart) || cycleTick >= windowTick(windows.dayStart))
        return 'day';
    if (cycleTick < windowTick(windows.nightStart))
        return 'dusk';
    if (cycleTick < windowTick(windows.dawnStart))
        return 'night';
    return 'dawn';
}
export function getCampaignV2DayNightEffectsAtTick(tick) {
    const phase = resolvePhaseAtTick(tick);
    return { phase, ...CAMPAIGN_V2_DAY_NIGHT_PHASE_EFFECTS[phase] };
}
/** Cosine-smoothed darkness: 0 at the start of the day, 1 at the middle of the cycle. */
export function nightFactorAtTick(tick) {
    const progress = (((tick % CYCLE_TICKS) + CYCLE_TICKS) % CYCLE_TICKS) / CYCLE_TICKS;
    return 0.5 - 0.5 * Math.cos(progress * Math.PI * 2);
}
